// material
import { Stack } from "@mui/material";
import "./Education.css";

// ----------------------------------------------------------------------

export default function ConnectWalletContent() {
  return (
    <Stack spacing={{ xs: 1, sm: 2 }}>
      <Stack
        alignItems="center"
        direction={{ xs: "column", md: "row" }}
        spacing={{ xs: 1, sm: 3 }}
        sx={{ borderBottom: "1px solid #ffffff80" }}
      >
        <Stack sx={{ width: "40%" }}>
          <img
            src="/assets/wallet.png"
            style={{ width: "100%", height: "auto" }}
          />
        </Stack>
        <Stack
          spacing={4}
          sx={{ width: { xs: "100%", lg: "55%" }, p: { xs: "0", md: "2%" } }}
        >
          <p className="digital_wallet_title">
            How to set up a digital wallet?
          </p>
          <Stack direction="row" spacing={2}>
            <p className="digital_wallet_txt">1.</p>
            <p className="digital_wallet_txt">
              A digital wallet is easily downloaded in your desktops/mobiles app
              store. Popular options include Coinbase and Metamask Only download
              from verified website
            </p>
          </Stack>

          <Stack direction="row" spacing={2}>
            <p className="digital_wallet_txt">2.</p>
            <p className="digital_wallet_txt">
              Create your account, unlike a custodial wallet, you are not
              revealing any personal information. Not even an email address.
            </p>
          </Stack>

          <Stack direction="row" spacing={2}>
            <p className="digital_wallet_txt">3.</p>
            <p className="digital_wallet_txt">
              Select a good password that you will remember but it's preferably
              complicated enough for hackers not being able to guess it or brute
              force it.
            </p>
          </Stack>

          <Stack direction="row" spacing={2}>
            <p className="digital_wallet_txt">4.</p>
            <p className="digital_wallet_txt">
              Like all good wallets you have a private key in order to prevent
              anybody from getting their hands on your assets. This key is
              yours, but if someone else gets their hands on it, they can access
              your funds.
            </p>
          </Stack>
        </Stack>
      </Stack>
      <Stack spacing={4} sx={{ borderBottom: "1px solid #ffffff80", p: 6 }}>
        <p className="digital_wallet_title">Easy steps:</p>

        <Stack direction="row" spacing={2}>
          <p className="digital_wallet_txt">1.</p>
          <p className="digital_wallet_txt">
            Set up wallet. Download the wallet to your desktop or mobile, OS or
            Android. Make sure you only download it from official websites. Make
            sure you consciously plan the safe keeping of your 12 words.
            Beginners are recommended to use Coinbase, easy to use, but lacks
            many features. For those a bit more advanced, seeking a deeper
            crypto experience we recommend Metamask.
          </p>
        </Stack>

        <Stack direction="row" spacing={2}>
          <p className="digital_wallet_txt">2.</p>
          <p className="digital_wallet_txt">
            Your wallet address. If you click on the receive icon, you will see
            a string of letters and numbers and also a QR-code. That is the
            address of your wallet. If you or someone else ever wants to send
            crypto to that wallet, they would need to copy that string of words
            into their send function in their wallets.
          </p>
        </Stack>
        <Stack direction="row" spacing={2}>
          <p className="digital_wallet_txt">3.</p>
          <p className="digital_wallet_txt">
            Sending crypto from your wallet. To send your crypto to another
            wallet, click on the send icon in your wallet. Paste the wallet
            address from the receiving party. Make sure that you are sending it
            the right blockchain network e.g. If you are sending bitcoin, make
            sure it is a Bitcoin network address.Enter the amount you want to
            send. You will be displayed your transaction amount, plus the
            network fee, you can approve or decline.
          </p>
        </Stack>
        <Stack direction="row" spacing={2}>
          <p className="digital_wallet_txt">4.</p>
          <p className="digital_wallet_txt">
            Interacting in Web3. Unlike web2 you don't interact with websites
            and applications via login and password.You simply connect your
            wallet to the application and are now passed the gated front. Take
            Opensea as an example. Opensea is currently the most used NFT
            marketplace in the world. You connect your wallet and it now lets
            you buy, trade and sell NFT’s on the marketplace. All your assets
            are stored in your wallet and not on Opensea.
          </p>
        </Stack>
      </Stack>
      <Stack sx={{ height: 500 }}></Stack>
    </Stack>
  );
}
